export const API_BASE =
  "https://silvamethod.in/manage/api/v2/managelead";

export const statuses = [
  "",
  "new",
  "contacted",
  "interested",
  "follow_up",
  "converted",
  "not_interested",
  "transferred",
];

export const outcomes = [
  "no_answer",
  "interested",
  "callback_later",
  "not_interested",
  "converted",
  "transferred",
];

export const assignees = [
  "Shyamal",
  "Avantika",
  "Komal",
];

export const inputClass =
  "w-full rounded-xl border border-slate-200 bg-white px-3 py-2.5 text-sm outline-none transition focus:border-slate-400";

export const buttonClass =
  "rounded-xl bg-slate-900 px-4 py-2.5 text-sm font-medium text-white transition hover:bg-slate-800 disabled:cursor-not-allowed disabled:opacity-50";

export const statusLabel = (value = "") =>
  value
    .replaceAll("_", " ")
    .replace(/\b\w/g, (char) =>
      char.toUpperCase()
    );

export async function apiRequest(
  url,
  options = {}
) {
  const response = await fetch(url, {
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },

    ...options,
  });

  const result = await response
    .json()
    .catch(() => ({}));

  if (!response.ok) {
    throw new Error(
      result.message || "Something went wrong"
    );
  }

  return result;
}